export enum paymentsActionTypes {
  SET_UNPOSTED_BATCHES_DATA_LOADING = 'SET_UNPOSTED_BATCHES_DATA_LOADING',
  SET_BATCHES_DATA_LOADING = 'SET_BATCHES_DATA_LOADING',
  FETCH_UNPOSTED_BATCHES_DATA = 'FETCH_UNPOSTED_BATCHES_DATA',
  FETCH_BATCHES_DATA = 'FETCH_BATCHES_DATA',
  SET_SHELVED_BATCHES_DATA_LOADING = 'SET_SHELVED_BATCHES_DATA_LOADING',
  FETCH_SHELVED_BATCHES_DATA = 'FETCH_SHELVED_BATCHES_DATA',
  SET_BATCHES_TO_DEFAULT = 'SET_BATCHES_TO_DEFAULT',

  FETCH_LOADING_FAIL = 'FETCH_LOADING_FAIL',
  PAYMENT_GATEWAY_DATA = 'PAYMENT_GATEWAY_DATA',
  START_PAYMENT_GATEWAY_DATA_LOADING = 'START_PAYMENT_GATEWAY_DATA_LOADING',
  PAYMENT_GATEWAY_TYPE = 'PAYMENT_GATEWAY_TYPE',
  SET_PAYMENT_GATEWAY_TYPE_LOADING = 'SET_PAYMENT_GATEWAY_TYPE_LOADING',
  PROVIDER_PAYMENT_TYPE = 'PROVIDER_PAYMENT_TYPE',
  FETCH_PROVIDER_DATA = 'FETCH_PROVIDER_DATA',
  SET_PROVIDER_DATA_LOADING = 'SET_PROVIDER_DATA_LOADING',
  START_PAYMENT_REPORT_TYPES_LIST_LOADING = 'START_PAYMENT_REPORT_TYPES_LIST_LOADING',
  FETCH_PAYMENT_REPORT_TYPES_LIST = 'FETCH_PAYMENT_REPORT_TYPES_LIST',
  START_SET_PAYMENT_REPORT_LOADING = 'START_SET_PAYMENT_REPORT_LOADING',
  END_SET_PAYMENT_REPORT_LOADING = 'END_SET_PAYMENT_REPORT_LOADING',
  FETCH_DISPUTE_TYPES = 'FETCH_DISPUTE_TYPES',
  FETCH_PAYMENT_INSTRUMENT_DATA = 'FETCH_PAYMENT_INSTRUMENT_DATA',
  FETCH_PAYMENT_INSTRUMENT_DATA_LOADING = 'FETCH_PAYMENT_INSTRUMENT_DATA_LOADING',
  SET_EXPORT_CSV_LOADING = 'SET_EXPORT_CSV_LOADING',
  SET_DISPUTE_LOADING = 'SET_DISPUTE_LOADING',
  SET_PAYOUTS_TABLE_DATA_DEFAULT = 'SET_PAYOUTS_TABLE_DATA_DEFAULT',
  SET_FETCH_PARTNER_BANK_LOADING = 'SET_FETCH_PARTNER_BANK_LOADING',
  FETCH_PARTNER_BANK = 'FETCH_PARTNER_BANK',
  SET_BATCH_TYPES = 'SET_BATCH_TYPES',
  SET_BATCH_SENDER_FILTER = 'SET_BATCH_SENDER_FILTER',
  SET_PROVIDERS_FILTERS = 'SET_PROVIDERS_FILTERS',
  SET_PROVIDERS_LIST_TO_DEFAULT = 'SET_PROVIDERS_LIST_TO_DEFAULT',
  SET_PAYMENT_GATEWAY_REGISTER_LIST_LOADING = 'SET_PAYMENT_REGISTER_GATEWAY_LIST_LOADING',
  FETCH_PAYMENT_GATEWAY_REGISTER_LIST = 'FETCH_PAYMENT_GATEWAY_REGISTER_LIST',
  SET_PAYMENT_GATEWAY_LISTS_LOADING = 'SET_PAYMENT_GATEWAY_LISTS_LOADING',
  FETCH_PAYMENT_GATEWAY_LISTS = 'FETCH_PAYMENT_GATEWAY_LISTS',
  SET_NEW_PROVIDER_LOADING = 'SET_NEW_PROVIDER_LOADING',
  SET_UPDATING_FINANCIAL_ACCOUNT_LOADING = 'SET_UPDATING_FINANCIAL_ACCOUNT_LOADING',
  FETCH_ENTITY_TYPES = 'FETCH_ENTITY_TYPES',
  SET_PARTNER_BANK_VERIFICATION_LOADING = 'SET_PARTNER_BANK_VERIFICATION_LOADING',
}
